import { GET_USER_ORDERS, SET_USER_ORDERS, SET_ORDER_CANCELLATION, SET_ORDERS_REBOOKING, SET_ORDER_DETAIL } from "../../shared/constants";

const iniCancellation = {
	orders: null,
	fetchingOrders: false,
	orderToCancel: null,
	ordersToRebooking: null
};

/** 
 * TODO: Refatorar o redux para englobar o escopo de minhas viagens
 */
export const cancellation = (state = iniCancellation, action) => {
	switch (action.type) {
		case GET_USER_ORDERS:
			return {
				...state,
				fetchingOrders: true,
				orderToCancel: null
			};

		case SET_USER_ORDERS:
			return {
				...state,
				orders: action.orders
			};

		case SET_ORDER_CANCELLATION:
			return {
				...state,
				orderToCancel: action.orderToCancel
			};

		case SET_ORDER_DETAIL:
			return {
				...state,
				orderToDetail: action.orderToDetail
			};

		case SET_ORDERS_REBOOKING:
			return {
				...state,
				ordersToRebooking: action.ordersToRebooking
			}

		default:
			return state;
	}
};
